import { render } from "./VariantMenu.vue?vue&type=template&id=7663db32&scoped=true"
import script from "./VariantMenu.vue?vue&type=script&lang=js"
export * from "./VariantMenu.vue?vue&type=script&lang=js"

import "./VariantMenu.vue?vue&type=style&index=0&id=7663db32&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7663db32"]])

export default __exports__